<template>
  <div v-show="loader.show" id="loader" class="zin-999" data-test-id="loader">
    <v-dialog :value="loader.show" hide-overlay persistent min-width="310" max-width="500" class="zin-999">
      <v-card class="pt-4 pb-2" color="primary" :data-test-id="$tid('loader', 'loader-dialog')">
        <v-card-text class="text-truncate">
          <p class="subtitle-1 font-weight-medium white--text" :data-test-id="$tid('loader', 'loader-dialog__message')">
            {{ loader.message }}
          </p>
          <v-progress-linear indeterminate color="white" class="mt-4" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useLoaderStore } from '@/store/stores';

export default defineComponent({
  name: 'Loader',
  computed: {
    ...mapState(useLoaderStore, ['loader']),
  },
});
</script>
<style>
#loader {
  width: 100vw;
  height: 100vh;
  z-index: 100;
  position: fixed;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.59);
}
.zin-999 {
  z-index: 999 !important;
}
</style>
